import { NgModule } from '@angular/core';
import { AuthGuard } from './auth.guard';
import { UsersService } from './users.service';
import { HttpModule } from '@angular/http'
import { BrandsService } from "./brands.service"
import { StoresService } from "./stores.service"
import { ProductsService } from './products.service'
import { SweetAlertService } from "./sweetalert.service";
// import { RolePipe } from './role.pipe'

@NgModule({
  imports:[
    HttpModule
  ],
  declarations:[
    // RolePipe
  ],
  providers: [
    AuthGuard,
    UsersService,
    BrandsService,
    StoresService,
    ProductsService,
    SweetAlertService
  ],
  exports:[
    // RolePipe
  ],
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts